import { TelegramIcon, VKIcon, WhatsAppIcon } from '@/utils/icons'
import {
  FacebookOutlined,
  InstagramOutlined,
  TwitterOutlined,
  LinkedinOutlined,
} from '@ant-design/icons'
import { HTMLAttributes, ReactNode } from 'react'
import { ReactElementProps } from 'react-imask/dist/mixin'

enum LINK_TYPE {
  TELEGRAM = 'Telegram',
  WHATSAPP = 'WhatsApp',
  FACEBOOK = 'Facebook',
  INSTAGRAM = 'Instagram',
  TWITTER = 'Twitter',
  X = 'X',
  LINKEDIN = 'LinkedIn',
  TIKTOK = 'TikTok',
  VIBER = 'Viber',
  DISCORD = 'Discord',
  SNAPCHAT = 'Snapchat',
  VK = 'VK',
  UNDEFINED = 'UndefinedLink',
}

const detectLinkType = (url: string): LINK_TYPE => {
  const lowerUrl = url.toLowerCase();
  
  if (/^https?:\/\/t\.me\/.+/.test(lowerUrl)) return LINK_TYPE.TELEGRAM;
  if (/^https?:\/\/(?:wa\.me\/|web\.whatsapp\.com)/.test(lowerUrl)) return LINK_TYPE.WHATSAPP;
  if (/^https?:\/\/(?:facebook\.com\/|fb\.me\/)/.test(lowerUrl)) return LINK_TYPE.FACEBOOK;
  if (/^https?:\/\/instagram\.com\//.test(lowerUrl)) return LINK_TYPE.INSTAGRAM;
  if (/^https?:\/\/twitter\.com\//.test(lowerUrl)) return LINK_TYPE.TWITTER;
  if (/^https?:\/\/x\.com\//.test(lowerUrl)) return LINK_TYPE.X;
  if (/^https?:\/\/linkedin\.com\//.test(lowerUrl)) return LINK_TYPE.LINKEDIN;
  if (/^https?:\/\/tiktok\.com\//.test(lowerUrl)) return LINK_TYPE.TIKTOK;
  if (/^viber:\/\//.test(lowerUrl)) return LINK_TYPE.VIBER;
  if (/^https?:\/\/(?:discord\.com\/|discord\.gg\/)/.test(lowerUrl)) return LINK_TYPE.DISCORD;
  if (/^https?:\/\/snapchat\.com\//.test(lowerUrl)) return LINK_TYPE.SNAPCHAT;
  if (/^https?:\/\/vk\.com\//.test(lowerUrl)) return LINK_TYPE.VK;

  return LINK_TYPE.UNDEFINED;
}

interface ILinkIcon extends HTMLAttributes<HTMLElement> {
  fallback?: ReactNode | null
  link: string | null
}

const LinkIcon = ({
  fallback = null,
  link,
  ...props
}: ILinkIcon): ReactNode | null | undefined => {
  if(!link) return fallback
  
  const type = detectLinkType(link)

  switch (type) {
    case LINK_TYPE.TELEGRAM:
      return <TelegramIcon {...props} />
    case LINK_TYPE.WHATSAPP:
      return <WhatsAppIcon {...props} />
    case LINK_TYPE.FACEBOOK:
      return <FacebookOutlined onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} {...props} />
    case LINK_TYPE.INSTAGRAM:
      return <InstagramOutlined onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} {...props} />
    case LINK_TYPE.TWITTER:
      return <TwitterOutlined onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} {...props} />
    case LINK_TYPE.X:
      return fallback
    case LINK_TYPE.LINKEDIN:
      return <LinkedinOutlined onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} {...props} />
    case LINK_TYPE.TIKTOK:
      return fallback
    case LINK_TYPE.VIBER:
      return fallback
    case LINK_TYPE.DISCORD:
      return fallback
    case LINK_TYPE.SNAPCHAT:
      return fallback
    case LINK_TYPE.VK:
      return <VKIcon {...props} />
    default:
      return fallback
  }
}

export { LINK_TYPE, detectLinkType, LinkIcon }
